import { IconButton } from "@similarweb/ui-components";

import { RowSelectionConsumer } from "app/components/React/Table/cells/RowSelection";
import { SelectAllRowsHeaderCellConsumer } from "app/components/React/Table/headerCells/SelectAllRowsHeaderCell";
import { i18nFilter } from "app/filters/i18nFilter";
import { TrafficShareWithTooltip } from "pro-features/components/TrafficShare/src/TrafficShareWithTooltip";

import {
    IndexCell,
    ReferringCategoryCell,
    TrafficShareWithVisits,
    WebsiteTooltipTopCell,
} from "../../../../components/React/Table/cells";
import { DefaultCellHeader, HeaderCellBlank } from "../../../../components/React/Table/headerCells";
import { DEFAULT_SORT_DIRECTION, DEFAULT_SORT_FIELD } from "../incomingTrafficConsts";

const i18n = i18nFilter();
export const IncomingTrafficCompareTableSettings = {
    defaultSortField: DEFAULT_SORT_FIELD,
    defaultSortDirection: DEFAULT_SORT_DIRECTION,
    searchFieldName: "domain",
    getColumns: (
        sortedColumn = { field: DEFAULT_SORT_FIELD, sortDirection: DEFAULT_SORT_DIRECTION },
        useSelection,
        _webSource?,
        isDaily = false,
        _showEngagementScore?,
        _handleOpenQualificationSideBar = undefined,
        _isUSState?,
    ) => {
        const columns: any = [
            {
                fixed: true,
                cellComponent: ({ row }) => {
                    return (
                        <>
                            {!row.parent ? (
                                <IconButton
                                    iconName="chev-right"
                                    type="flat"
                                    className="enrich"
                                />
                            ) : null}
                        </>
                    );
                },
                sortable: false,
                headerComponent: HeaderCellBlank,
                isResizable: false,
                width: 40,
                columnClass: "collapseControlColumn", // optional
                cellClass: "collapseControlCell", // optional
                disableHeaderCellHover: true,
            },
            {
                fixed: true,
                cellComponent: RowSelectionConsumer,
                sortable: false,
                width: 40,
                headerComponent: SelectAllRowsHeaderCellConsumer,
                isResizable: false,
                visible: useSelection,
            },
            {
                fixed: true,
                cellComponent: IndexCell,
                headerComponent: HeaderCellBlank,
                disableHeaderCellHover: true,
                sortable: false,
                isResizable: false,
                width: 40,
            },
            {
                minWidth: 224,
                isResizable: true,
                sortable: true,
                field: "Domain",
                showTotalCount: true,
                displayName: i18n("analysis.source.referrals.table.columns.domain.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.domain.title.tooltip"),

                cellComponent: WebsiteTooltipTopCell,
            },
            {
                minWidth: 240,
                isResizable: true,
                sortable: true,
                field: "Category",
                displayName: i18n("analysis.source.referrals.table.columns.category.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.category.title.tooltip"),
                cellComponent: ReferringCategoryCell,
            },
            {
                minWidth: 138,
                isResizable: true,
                sortable: true,
                field: "TotalShare",
                displayName: i18n("analysis.source.search.all.table.columns.totalShareCompare.title"),
                tooltip: i18n("analysis.source.search.all.table.columns.totalShareCompare.general.title.tooltip"),
                cellComponent: (props) => (
                    <TrafficShareWithVisits
                        {...props}
                        applyAbbrNumberFilter={true}
                    />
                ),
            },
            {
                field: "trafficDistribution",
                width: 182,
                displayName: i18n("analysis.source.search.all.table.columns.shareCompare.title"),
                tooltip: i18n("analysis.source.search.all.table.columns.shareCompare.title.tooltip"),
                cellComponent: ({ value, tooltipTitle }) => {
                    return (
                        <TrafficShareWithTooltip
                            data={value}
                            title={tooltipTitle}
                        />
                    );
                },
                tooltipTitle: i18n("incomingtraffic.competitivetrafficshare.tooltip"),
            },
        ];
        return columns.map((col: any) => {
            const isSorted = sortedColumn && col.field === sortedColumn.field;
            return {
                ...col,
                visible: col.visible !== false,
                headerComponent: col.headerComponent || DefaultCellHeader,
                isSorted,
                sortDirection: isSorted ? sortedColumn.sortDirection : DEFAULT_SORT_DIRECTION,
            };
        });
    },
};
